module.exports = __webpack_public_path__ + "static/media/es-default.1719b7ce.svg";


//////////////////
// WEBPACK FOOTER
// ./src/themes/default/img/es-default.svg
// module id = 592
// module chunks = 4